import { ADD_RESERVACION, RESET } from '../actions/Reservacion';

let reservacion = {
    LugarRecepcion: {},
    FechaRecepcion: new Date(),
    LugarDevolucion: {},
    FechaDevolucion: new Date(),
    Dias: 0,
    DiasDescuento: 0
}

const reservacionReducer = (state = reservacion, action) => {
    switch (action.type) {
        case ADD_RESERVACION:
            return action.reservacion
        case RESET:
            return reservacion;
        default:
            return state;
    }
}

export default reservacionReducer;
